import turntable from "../../assets/Turntable-comp.gif";
import React, { useEffect } from "react";

import "aos/dist/aos.css";
import Aos from "aos";
function Presentations(props) {
  useEffect(() => {
    Aos.init({ duration: 3000 });
  });
  return (
    <a id="about" href>
      <div className="flex flex-col md:flex-row lg:justify-around bg-[#0A0912] w-full z-30 p-10 2xl:px-[350px] md:px-40 xl:px-[250px] md:py-[200px]">
        <div
          data-aos="zoom-in"
          className="tracking-wider z-10 md:mt-10 md:w-5/12 2xl:w-4/12"
        >
          <h1 className="text-transparent  bg-clip-text mb-8 font-bold bg-gradient-to-r from-[#8926B6] to-[#EABCFF] text-2xl md:text-3xl lg:text-5xl 2xl:text-[56px] ">
            11,111 of the finest hands in the metaverse
          </h1>

          <p
            data-aos="zoom-out"
            className="mt-5 tracking-tight letter-spacing:-0.05em font-regular text-[#747397] text-[18px]"
          >
            The HandiVerse is a collection of 11,111 unique digital NFTs
            launched on the Ethereum blockchain. Handitars are on a mission to
            give a hand to those who need one.
          </p>
          <p className="mt-5 tracking-tight letter-spacing:-0.05em  text-[#747397] text-[18px]">
            A percentage of project proceeds will go to support amputees around
            the world.
          </p>
        </div>

        <div
          data-aos-anchor-placement="top-center"
          className="z-10 md:mt-[-110px] w-full md:w-7/12 h-full lg:w-5/12 "
        >
          <div
            style={{ overflow: "hidden" }}
            id="circleWithAvatar"
            className="relative flex justify-center h-full circleWithAvatar "
          >
            <img
              className="w-full md:w-11/12 rounded-md lg:w-full 2xl:w-full md:mt-[150px] mt-[50px]"
              src={turntable}
              alt=""
            />
          </div>
        </div>
      </div>
    </a>
  );
}

export default Presentations;
